
import { EMPTY_INTERFACE_MONITORING_ENTITY, InterfaceMonitoringEntity } from "domain/entity/InterfaceMonitoring/InterfaceMonitoringEntity";
import { EMPTY_INTERFACE_MONITORING_SEARCH_CRITERIA, InterfaceMonitoringSearchCriteria } from "domain/entity/InterfaceMonitoring/InterfaceMonitoringSearchCriteria";
import { InterfaceMonitoringRepository } from "domain/repository/InterfaceMonitoring/InterfaceMonitoringRepo";
import _ from "lodash";
import { InterfaceMonitoringStatusDroOpts } from "presentation/constant/DropDownOptions/Document/InterfaceMonitoringStatusDroOpts";
import { DropdownProps } from "presentation/model/DropdownProps";
import { EbisInterfaceMonitoringMaintenanceModel } from "presentation/model/EbisInterfaceMonitoring/EbisInterfaceMonitoringMaintenanceModel";
import { Dispatch, SetStateAction } from "react";
import { IFieldValue } from "veronica-ui-component/dist/component/core";
import BaseViewModel from "../BaseViewModel";

interface EbisInterfaceMonitoringMaintenanceVMProps extends BaseViewModel {
    dispatch: [
        Dispatch<SetStateAction<EbisInterfaceMonitoringMaintenanceModel>> | ((value: SetStateAction<EbisInterfaceMonitoringMaintenanceModel>) => void),
    ],
    repo: InterfaceMonitoringRepository,
}

export const EbisInterfaceMonitoringMaintenanceVM = ({ dispatch, repo }: EbisInterfaceMonitoringMaintenanceVMProps) => {
    const [ebisInterfaceMonitoringMainDispatch] = dispatch;

    const onSearch = async (searchCriteria: InterfaceMonitoringSearchCriteria) => {
        searchCriteria = {
            ...searchCriteria,
            type: 'ebis'
        }
        return await repo.searchEbisInterfaceMonitoringList(searchCriteria).then((data) => {
            ebisInterfaceMonitoringMainDispatch(prevState => {
                return {
                    ...prevState,
                    tableData: data,
                    selectedRows: [],
                    searchCriteria: { ...searchCriteria },
                }
            })
        }).catch((error) => {
            return [];
        })
    }

    const onSearchDetail = async (searchCriteria: InterfaceMonitoringSearchCriteria) => {

        return await repo.searchInterfaceMonitoringDetail(searchCriteria).then((data) => {
            ebisInterfaceMonitoringMainDispatch(prevState => {
                return {
                    ...prevState,
                    ebisInterfacemonitoringDtlList: data,
                    // currentSelectedRow: (data !==null && data.length >0)? data[0]:{...EMPTY_INTERFACE_MONITORING_ENTITY},
                    selectedRows: [],
                }
            })
        }).catch((error) => {
            return [];
        })
    }

    const onRowDoubleClick = async (entity: InterfaceMonitoringEntity) => {
        let newSearchCriteria = {
            ...EMPTY_INTERFACE_MONITORING_SEARCH_CRITERIA,
            interfaceMonitorHdrId: entity.interfaceMonitorHdrId,
            messageType: entity.messageType
        };
        await repo.searchInterfaceMonitoringDetail(newSearchCriteria).then((data) => {
            ebisInterfaceMonitoringMainDispatch(prevState => {
                return {
                    ...prevState,
                    currentSelectedRow: entity,
                    isShowSearchPanel: false,
                    isShowDetailPanel: true,
                    ebisInterfacemonitoringDtlList: data
                }
            })

        });
    }

    const loadDropdownOption = async () => {

        await repo.searchInterfaceTypeCombobox("EBIS").then(typeList => {

            let messageTypeDropdownOption: DropdownProps[] = [];
            let fromDropdownOption: DropdownProps[] = [];
            let toDropdownOption: DropdownProps[] = [];
            typeList?.forEach(type => {
                const msgTypeExisted = messageTypeDropdownOption?.find(msgType =>
                    msgType.value === type.messageType);
                const fromExisted = fromDropdownOption?.find(msgType =>
                    msgType.value === type.from);
                const toExisted = toDropdownOption?.find(msgType =>
                    msgType.value === type.to);

                if (!msgTypeExisted) {
                    messageTypeDropdownOption.push({
                        dropdownLabel: type.messageType,
                        tagLabel: type.messageType,
                        value: type.messageType
                    })
                }
                if (!fromExisted) {
                    fromDropdownOption.push({
                        dropdownLabel: type.from,
                        tagLabel: type.from,
                        value: type.from
                    })
                }
                if (!toExisted) {
                    toDropdownOption.push({
                        dropdownLabel: type.to,
                        tagLabel: type.to,
                        value: type.to
                    })
                }
            })

            ebisInterfaceMonitoringMainDispatch(prevState => ({
                ...prevState,
                dynamicOptions: {
                    ...prevState.dynamicOptions,
                    messageTypeDropdownOptions: messageTypeDropdownOption,
                    formDropdownOptions: fromDropdownOption,
                    toDropdownOptions: [...toDropdownOption].reverse()
                }
            }))
        })

        ebisInterfaceMonitoringMainDispatch(prevState => ({
            ...prevState,
            dynamicOptions: {
                ...prevState.dynamicOptions,
                statusDropdownOptions: InterfaceMonitoringStatusDroOpts().getEbisInvSendingStatusModel()
            }
        }))

    }

    const onResend = async (currentRows: InterfaceMonitoringEntity[]) => {
        return await repo.onEbisResend(currentRows);
    }

    const onRemoveAllSearchCriteria = () => {
        ebisInterfaceMonitoringMainDispatch(prevState => {
            return {
                ...prevState,
                searchCriteria: { ...EMPTY_INTERFACE_MONITORING_SEARCH_CRITERIA }
            }
        })
    }

    const onSearchFieldChange = async (fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) => {
        let val: any = fieldValue;

        ebisInterfaceMonitoringMainDispatch(prevState => {
            return {
                ...prevState,
                searchCriteria: {
                    ...prevState.searchCriteria,
                    [fieldKey]: val,
                },
            }
        })
    }

    const onFieldChange = (fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) => {
        let val: any = fieldValue;
        if (_.isArray(val)) {
            val = _.uniq(val?.map((item: any) => item.value || item.key));
        }

        ebisInterfaceMonitoringMainDispatch(prevState => ({
            ...prevState,
            currentSelectedRow: {
                ...prevState.currentSelectedRow,
                [fieldKey]: val
            }
        }))
    }

    const onSearchClick = async () => {
        ebisInterfaceMonitoringMainDispatch(prevState => {
            return {
                ...prevState,
                isShowSearchPanel: !prevState.isShowSearchPanel
            }
        });
    }

    const onSelectedEbisInterfaceMonitoring = (selectedRows: InterfaceMonitoringEntity[]) => {
        ebisInterfaceMonitoringMainDispatch(prevState => {
            return {
                ...prevState,
                selectedRows: selectedRows,
                currentSelectedRow: (selectedRows.length === 1 ? selectedRows[0] : EMPTY_INTERFACE_MONITORING_ENTITY),
                forceRefresh: !prevState.forceRefresh
            }
        })
    }

    const onCancel = () => {
        ebisInterfaceMonitoringMainDispatch(prevState => {
            return {
                ...prevState,
                currentSelectedRow: EMPTY_INTERFACE_MONITORING_ENTITY,
                isShowDetailPanel: false,
                isShowSearchPanel: false,
                ebisInterfacemonitoringDtlList: [],
                viewState: {
                    ...prevState.viewState,
                    isAdd: false,
                    isEditable: false,
                    isSliderOpen: false,
                    allFormState: {},
                }
            }
        })
    }

    const onHeaderFieldChange = async (fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) => {
        let val: any = fieldValue;
        if (_.isArray(val)) {
            val = _.uniq(val?.map((item: any) => item.value || item.key));
        }

        ebisInterfaceMonitoringMainDispatch(prevState => {
            return {
                ...prevState,
                currentSelectedRow: {
                    ...prevState.currentSelectedRow,
                    [fieldKey]: val,
                },
            }
        })
    }

    const onDateRangeChange = (startDate: any, endDate: any, dateFields: { startField: string, endField: string }) => {
        ebisInterfaceMonitoringMainDispatch(prevState => ({
            ...prevState,
            searchCriteria: {
                ...prevState.searchCriteria,
                [dateFields.startField]: startDate,
                [dateFields.endField]: endDate,
            }
        }))
    }

    const setIsSearchLoading = (isSearchLoading: boolean) => {
        ebisInterfaceMonitoringMainDispatch(prevState => {
            return {
                ...prevState,
                isSearchLoading: isSearchLoading,
            }
        })
    }


    return {
        onDateRangeChange: onDateRangeChange,
        loadDropdownOption: loadDropdownOption,
        onSearch: onSearch,
        onSearchDetail: onSearchDetail,
        onResend: onResend,
        onRowDoubleClick: onRowDoubleClick,
        onRemoveAllSearchCriteria: onRemoveAllSearchCriteria,
        onSearchFieldChange: onSearchFieldChange,
        onFieldChange: onFieldChange,
        onSearchClick: onSearchClick,
        onSelectedEbisInterfaceMonitoring: onSelectedEbisInterfaceMonitoring,
        onCancel: onCancel,
        onHeaderFieldChange: onHeaderFieldChange,
        setIsSearchLoading: setIsSearchLoading,
    }
}